export function buildBrushDetails(range, data, dataKey = 'date') {
  if (!range || !Array.isArray(data) || data.length === 0) return null;
  const { startIndex, endIndex } = range;
  if (typeof startIndex !== 'number' || typeof endIndex !== 'number') {
    return null;
  }

  const clamp = (index) => Math.max(0, Math.min(data.length - 1, index));
  const startIdx = clamp(startIndex);
  const endIdx = clamp(endIndex);

  const startEntry = data[startIdx];
  const endEntry = data[endIdx];
  if (!startEntry || !endEntry) return null;

  return {
    ...range,
    startIndex: startIdx,
    endIndex: endIdx,
    startValue: startEntry[dataKey],
    endValue: endEntry[dataKey]
  };
}

